'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _actions = require('../../actions');

var _Core = require('../Core');

var _Logo = require('../Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _ChevronIcon = require('../Icon/ChevronIcon');

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var wrapperStyle = function wrapperStyle() {
  return {
    desktop: {
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    }
  };
};

var pagesStyle = function pagesStyle() {
  return {
    margin: '4px 0 40px',
    position: 'relative',
    ':after': {
      content: '""',
      width: 'calc(100% - 44px)',
      height: '1px',
      left: '22px',
      bottom: '-20px',
      backgroundColor: '#e0e0e0',
      position: 'absolute'
    },
    desktop: {
      flex: 1,
      margin: 0,
      ':after': {
        width: '1px',
        height: '100%',
        top: '0',
        left: 'auto',
        right: '0'
      }
    }
  };
};

var productsStyle = function productsStyle() {
  return {
    margin: '12px 8px'
  };
};

var productNameStyle = function productNameStyle() {
  return {
    display: 'block',
    padding: '0 16px',
    margin: '0 0 6px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#666'
  };
};

var productSquareStyle = function productSquareStyle() {
  return {
    width: '32px',
    height: '32px',
    marginRight: '16px'
  };
};

var pageIconStyle = function pageIconStyle() {
  return {
    marginRight: '8px'
  };
};

var linkStyle = function linkStyle() {
  return {
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
    padding: '6px 16px',
    textDecoration: 'none',
    color: '#666',
    outline: 'none',
    fontSize: '14px',
    transition: 'opacity 0.2s ease-in-out',
    willChange: 'opacity',
    opacity: '1',
    ':hover': {
      color: '#666',
      opacity: '0.75',
      textDecoration: 'none'
    },
    desktop: {
      marginTop: '10px'
    }
  };
};

var extend = {
  wrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: '32px 0 16px',
    borderRadius: '3px',
    border: 'solid 1px #e0e0e0',
    flexDirection: 'column',
    desktop: {
      height: '100%',
      width: 'auto',
      margin: '0',
      border: 'none',
      flexDirection: 'row'
    }
  },
  dropdownContent: {
    border: 'none',
    desktop: {
      width: '536px',
      padding: '32px 16px 32px'
    }
  }
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);
var Pages = (0, _preactFela.createComponent)(pagesStyle);
var PageIcon = (0, _preactFela.createComponent)(pageIconStyle, _ChevronIcon2.default, ['color', 'placement']);
var Products = (0, _preactFela.createComponent)(productsStyle);
var ProductName = (0, _preactFela.createComponent)(productNameStyle, 'span');
var ProductSquare = (0, _preactFela.createComponent)(productSquareStyle, _Logo2.default, ['product', 'square']);
var Link = (0, _preactFela.createComponentWithProxy)(linkStyle, 'a');

var NavbarSerasaConsumidor = function (_Component) {
  _inherits(NavbarSerasaConsumidor, _Component);

  function NavbarSerasaConsumidor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavbarSerasaConsumidor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavbarSerasaConsumidor.__proto__ || Object.getPrototypeOf(NavbarSerasaConsumidor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.toggle = function () {
      _this.setState({ open: !_this.state.open });
    }, _this.handleClickPage = function (event, label) {
      var proxy = _this.props.config.proxy;


      (0, _actions.analyticsEvent)('oque-precisa-' + label);

      if (proxy) {
        proxy(event, function () {
          return _this.setState({ open: false });
        });
      }
    }, _this.handleClickProduct = function (event) {
      var proxy = _this.props.config.proxy;


      if (proxy) {
        proxy(event, function () {
          return _this.setState({ open: false });
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavbarSerasaConsumidor, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.inScroll !== prevProps.inScroll) {
        this.setState({ open: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mobile = _props.mobile,
          inScroll = _props.inScroll,
          hasMenus = _props.hasMenus,
          config = _props.config,
          heimdall = _props.heimdall,
          _props$login = _props.login,
          login = _props$login === undefined ? {} : _props$login,
          _props$signUp = _props.signUp,
          signUp = _props$signUp === undefined ? {} : _props$signUp;
      var pages = heimdall.pages,
          products = heimdall.products;


      if (!mobile && inScroll && hasMenus) {
        return null;
      }

      var isLoginAndSignUpDisabled = login.disabledInNavbar && signUp.disabledInNavbar;

      var firstDivider = !mobile && !isLoginAndSignUpDisabled && (0, _preact.h)(_Core.Dividir, null);
      var lastDivider = !mobile && !isLoginAndSignUpDisabled && (0, _preact.h)(_Core.Dividir, null);

      return (0, _preact.h)(
        Wrapper,
        null,
        firstDivider,
        (0, _preact.h)(
          _Core.Dropdown,
          { label: 'O que voc\xEA precisa?', mobile: mobile, config: config, styleExtend: extend, inside: mobile, open: this.state.open, toggle: this.toggle, gtm: (0, _utils.getAttrsGtm)("O que você precisa?", { clicktype: 'menu' }) },
          (0, _preact.h)(
            Pages,
            null,
            pages.map(function (_ref2) {
              var label = _ref2.label,
                  id = _ref2.id,
                  url = _ref2.url;
              return (0, _preact.h)(
                Link,
                _extends({ key: id, href: url, onClick: function onClick(event) {
                    return _this2.handleClickPage(event, label);
                  }, title: label }, (0, _utils.getAttrsGtm)(label, { clicktype: 'submenu' })),
                [(0, _preact.h)(PageIcon, { color: '#666', placement: 'left' }), label]
              );
            })
          ),
          (0, _preact.h)(
            Products,
            null,
            !mobile && (0, _preact.h)(
              ProductName,
              null,
              'Produtos'
            ),
            products.map(function (product) {
              return (0, _preact.h)(
                Link,
                _extends({ key: product.key, href: product.url, title: product.name, onClick: _this2.handleClickProduct }, (0, _utils.getAttrsGtm)(product.name, { clicktype: 'submenu' })),
                [(0, _preact.h)(ProductSquare, { product: product.key, square: true }), product.name]
              );
            })
          )
        ),
        lastDivider
      );
    }
  }]);

  return NavbarSerasaConsumidor;
}(_preact.Component);

exports.default = NavbarSerasaConsumidor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Navbar/NavbarSerasaConsumidor.js
// module id = 60
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38